export const SPHERE_VERT = `
attribute float sPhi;
attribute float sTheta;
uniform float uTime;
uniform float uDpr;
varying float vCamZ;
varying float vColorT;

vec3 deform(float phi, float theta, float t) {
  float dx = sin(phi * 1.7 + theta * 0.9 + t * 0.29) * 0.40
           + sin(phi * 0.6 - theta * 1.5 - t * 0.22) * 0.26;
  float dy = sin(theta * 1.5 + phi * 1.2 - t * 0.25) * 0.40
           + sin(phi * 2.1 - theta * 0.7 + t * 0.20) * 0.26;
  float dz = sin(phi * 1.3 + theta * 2.0 + t * 0.23) * 0.40
           + sin(theta * 0.8 - phi * 1.8 - t * 0.18) * 0.26;
  dx += sin(phi * 3.1 + theta * 1.8 - t * 0.40) * 0.13
      + sin(phi * 2.4 - theta * 2.7 + t * 0.33) * 0.08;
  dy += sin(theta * 3.4 - phi * 1.4 + t * 0.37) * 0.13
      + sin(phi * 3.7 + theta * 0.9 - t * 0.28) * 0.08;
  dz += sin(phi * 2.7 + theta * 3.1 - t * 0.34) * 0.13
      + sin(theta * 2.5 + phi * 2.2 + t * 0.26) * 0.08;
  dx += sin(phi * 5.2 + theta * 3.9 + t * 0.58) * 0.04;
  dy += sin(theta * 4.8 - phi * 4.3 - t * 0.53) * 0.04;
  dz += sin(phi * 4.6 + theta * 5.1 + t * 0.49) * 0.04;
  return vec3(dx, dy, dz);
}

void main() {
  float t = uTime;
  float bx = sin(sPhi) * cos(sTheta);
  float by = cos(sPhi);
  float bz = sin(sPhi) * sin(sTheta);
  vec3 d = deform(sPhi, sTheta, t);
  float R = 155.0;
  float breathe = 1.0 + sin(t * 0.18) * 0.04;
  vec3 pos = vec3(R * (bx + d.x), R * (by + d.y), R * (bz + d.z)) * breathe;
  float a = t * 0.035;
  float cosA = cos(a), sinA = sin(a);
  pos = vec3(pos.x * cosA - pos.z * sinA, pos.y, pos.x * sinA + pos.z * cosA);
  vec4 mvPos = modelViewMatrix * vec4(pos, 1.0);
  vCamZ = mvPos.z;
  float yNorm    = clamp(pos.y / (R * 1.9) + 0.5, 0.0, 1.0);
  float thetaNorm = sTheta / 6.2832;
  vColorT = yNorm * 0.82 + thetaNorm * 0.18;
  gl_PointSize = 2.4 * (500.0 / -mvPos.z) * uDpr;
  gl_Position  = projectionMatrix * mvPos;
}
`;

export const SPHERE_FRAG = `
varying float vCamZ;
varying float vColorT;

void main() {
  vec2 c = gl_PointCoord - 0.5;
  float d = length(c);
  if (d > 0.5) discard;
  float edge = 1.0 - smoothstep(0.40, 0.50, d);
  vec3 skyBlue  = vec3(0.329, 0.769, 0.929);
  vec3 adbBlue  = vec3(0.0,   0.490, 0.718);
  vec3 teal     = vec3(0.220, 0.690, 0.580);
  vec3 green    = vec3(0.643, 0.820, 0.396);
  vec3 color;
  float t = clamp(vColorT, 0.0, 1.0);
  if (t < 0.333) {
    color = mix(green, teal, t / 0.333);
  } else if (t < 0.667) {
    color = mix(teal, adbBlue, (t - 0.333) / 0.334);
  } else {
    color = mix(adbBlue, skyBlue, (t - 0.667) / 0.333);
  }
  float depth = clamp((-vCamZ - 240.0) / 610.0, 0.0, 1.0);
  float alpha  = mix(0.95, 0.22, depth) * edge;
  gl_FragColor = vec4(color, alpha);
}
`;
